import { render, staticRenderFns } from "./ImportsPrepaids.vue?vue&type=template&id=1249219a"
import script from "./ImportsPrepaids.vue?vue&type=script&lang=js"
export * from "./ImportsPrepaids.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports